/*

This file handles the user object for the currently signed in user



*/
import { browserHistory } from 'react-router'
import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var User = Class.create({
  	initialize: function() {
  		this.userInfo = null;
  		this.activeBuilding = null;
  		this.activeFloor = null;
		this.server = server;
		this.userPermissions = null;
		this.getUserData();
		this.getPermissions();
	},
	getUserData: function() {
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "user/authenticate";
		// #  Send to server object for processing
		var data = self.server.getData(url,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
				// #  In most cases if data is null, means user is no longer signed in
				// #  Authenticate user
				self.authenticateUser();
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			else
			{
				// #  Process our results
				self.setUserData(response);
			}
		})
		.fail(function(e){
			console.log(e);
			self.authenticateUser();
		});
	},
	getPermissions: function(callback = null) {
		var self = this;
		var url = "user/permissions";
		var data = self.server.getData(url,null, false);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1) {
				self.authenticateUser();
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			else
			{
				self.userPermissions = response.data;
				if (callback) {
					callback(response.data);
				}
			}
		})
		.fail(function(e){
			self.authenticateUser();
		});
	},
	getUserDataWithCallback: function(callback) {
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "user/authenticate";
		// #  Send to server object for processing
		var data = self.server.getData(url,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
				// #  In most cases if data is null, means user is no longer signed in
				// #  Authenticate user
				self.authenticateUser();
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			else
			{
				// #  Process our results
				self.setUserData(response);
				callback(response);
			}
		})
		.fail(function(e){
			self.authenticateUser();
		});
	},
	setUserData: function(response) {
		var self = this;
		// See if account billing was setup
		if(response.data.user_data.user_type_alias === 'admin' && response.data.user_data.billing_setup === false) {
			// TO TURN BACK ON MAYBE
			// if(window.location.pathname !== "/account/subscription"){
			// 	browserHistory.replace("/account/subscription");
			// }
		}
		// #  Set our data for our user
		this.userInfo = response.data.user_data;
		jQuery("header").css("display","block");
        jQuery(".left-sidebar").css("display","block");
		jQuery(".content").css({
			"padding": "",
			"margin": ""
		});


		if(window.location.pathname == "/login" || window.location.pathname == '/signup' || window.location.pathname == '/forgot' || window.location.pathname == '/screen' || window.location.pathname == '/signature' || window.location.pathname == "/vendor/login"){
			browserHistory.replace("/");
		} else {
			if (this.userInfo.view == 0 && response.data.user_data.user_type_alias == 'admin') {
				browserHistory.replace("/getstarted");
			}


			if (process.env.ENVIRONMENT != 'local' && process.env.ENVIRONMENT != 'develop') {
				setTimeout(function() {
					window.Intercom('boot', {
						app_id: "k7g1togq",
						name: "" + self.userInfo.username + "", // Full name
						email: "" + self.userInfo.username + "", // Email address
						alignment: "right",
						userView: self.userInfo.view,
						userType: "" + self.userInfo.user_type_alias + ""
					});
				}, 3000);
			}
		}
	},
	authenticateUser: function() {
		var isListingsPublic = window.location.pathname.includes('/listings/')
		// #  Means we have a login error
		// #  Redirect our user
		if(window.location.pathname != '/signup' && window.location.pathname != '/forgot' && window.location.pathname != '/screen' && window.location.pathname != '/signature' && !isListingsPublic && window.location.pathname != "/vendor/login") {
			browserHistory.replace('/login');
		}
	},
	setActiveFloor: function(floorData)
	{
		this.activeFloor = floorData;
	},
	// #  resets active floor data
	emptyActiveFloor: function() {
		this.activeFloor = null;
	},
	setActiveBuilding: function(buildingData)
	{
		this.activeBuilding = buildingData;
	},
	// #  resets active floor data
	emptyActiveBuilding: function() {
		this.activeBuilding = null;
	},
	logUserOff: function() {
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "user/logoff";
		var object = this;
		var params = null;
		// #  Send to server object for processing
		var data = this.server.getData(url,params,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
				// #  Means our user was logged off, lets point them to login
				// #  Redirect our user
				browserHistory.replace('/login');
			} else {
			}
		})
		.fail(function(e){
			console.log(e);
		});
	},
	logUserOn: function(username, password, callback){
		var self 	   = this;
		var fcmToken   = null;
		var deviceId   = null;
		const isMobile = localStorage.getItem('isFromMobileApp');
		if (typeof isMobile !== undefined && isMobile == 'true') {
			fcmToken   = localStorage.getItem('fcmToken');
			deviceId   = localStorage.getItem('deviceId');
		}
		var url 	   = "user/signin";
		var params 	   = {
			username: username,
			password: password,
			fcm_token: fcmToken,
			device_id: deviceId
		};
		var data 	   = this.server.getData(url,params,false, "POST");
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
				callback(response);
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				callback(response);
			}
			else
			{
				self.setUserData(response);
				browserHistory.replace('/');
			}
		})
		.fail(function(e){
			console.log(e);
			callback(false);
		});
	},
	checkEmail: function(email, callback, callback1) {
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "user/checkemail";
		var params = {'email': email};
		var object = this;
		// #  Send to server object for processing
		var data = this.server.getData(url,params,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
				callback(false);
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
				callback(false);
			}
			else
			{
				callback(response, callback1);
			}
		})
		.fail(function(e){
			console.log(e);
			callback(false);
		});
	},
	createPassword: function(data, callback) {
		var url = "user/password";
		var params = data
		var data = this.server.getData(url,params,false, "PUT");
		data
		.done(function(response){
			modal.showInfo("Your account password has been created!", "success", "top", "center");
			callback(response)
		})
		.fail(function(e){
			modal.showInfo("Hmm, something didn't work right.  Try again.", "danger", "top", "center");
			callback(e);
		});
	},
	savePassword: function(email, password, id, type, callback, callback1) {
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "user/createpassword";
		var params = {'password': password, 'email': email, 'id': id, 'account_type': type};
		var object = this;
		// #  Send to server object for processing
		var data = this.server.getData(url,params,false, "PUT");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
				callback(false);
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
				callback(false);
			}
			else
			{
				callback(response, callback1);
			}
		})
		.fail(function(e){
			console.log(e);
			callback(false);
		});
	},
	getPoContactInformation: function(callback) {
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "user/pocontact";
		// #  Send to server object for processing
		var data = self.server.getData(url,false);
		// #  Listen to our data
		data
		.done(function(response){
			if(callback) {
				callback(response);
			}
		})
		.fail(function(e){
			self.authenticateUser();
		});
	},
	getUserInfo: function(callback) {
		var self = this;
		var url = "user/info";
		var data = self.server.getData(url,false);
		data
		.done(function(response){
			if(callback) {
				callback(response);
			}
		})
		.fail(function(e){
			self.authenticateUser();
		});
	},
	updateUserAccount: function(user_info) {
		var self = this;
		var url = "user/info";
		var params = user_info;
		var data = this.server.getData(url,params,false, "PUT");
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			else
			{
				modal.showInfo("Your account information has been updated!", "success", "top", "center");
			}
		})
		.fail(function(e){
			console.log(e);
		});
	},
	resetPassword: function(password) {
		var self = this;
		var url = "user/resetpassword";
		var params = {
			password: password
		};
		modal.showDangerModalWithOK("Are you sure?","You are about to reset your password.","Yes, Reset");
		jQuery(".move-on").on('click',function() {
			var data = self.server.getData(url,params,false, "PUT");
			data
			.done(function(response){
				// #  Validate response
				if(response.data.error_user_authentication == 1)
				{
				}
				else if(response.data.error || (response.status == 1 || response.status == 2))
				{
				}
				else
				{
					modal.showInfo("Your password was updated!", "success", "top", "center");
				}
			})
			.fail(function(e){
				console.log(e);
			});
		});
	},
	resetPasswordWithoutValidation: function(data, callback) {
		var self = this;
		var url = "user/reset/password";
		var data = self.server.getData(url, data, true, "PUT");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			callback(false);
		});
	},
	getCommunityBoard: function(callback) {
		var self = this;
		var url = "user/communityboard";
		var data = self.server.getData(url,false);
		data
		.done(function(response){
			if(callback) {
				callback(response);
			}
		})
		.fail(function(e){
			self.authenticateUser();
		});
	},
	signUpUser: function(userData, referralLink = null, callback){
		var self 		   = this;
		var url 		   = "user/signup";
		var params 		   = userData;
		params['referral'] = referralLink;
		var data 		   = this.server.getData(url, params, true, "POST");
		data
		.done(function(response){
			modal.showInfo("Thank you for signing up!  You should receive a confirmation email shortly.", "success", "top", "center");
			self.getUserDataWithCallback(function(response) {
				callback(response);
			});
		})
		.fail(function(e){
			callback(e);
		});
	},
	confirmUser: function(token, callback) {
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "user/signup/confirm";
		var params = {
			token: token
		};
		// #  Send to server object for processing
		var data = this.server.getData(url,params,false, "POST");
		// #  Listen to our data
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			modal.showInfo("Looks like we couldn't confirm this account!  Make sure you clicked the link we sent to your email!", "warning", "top", "center");
			callback(e);
		});
	},
	saveUserView: function(type, callback) {
		var self = this;
		var url = "user/saveview";
		var data = this.server.getData(url, {view: type}, true, "POST");
		data
		.done(function(response){
			modal.showInfo("Great, let's get started!", "success", "top", "center");
			self.userInfo.view = type;
			callback(response);
		})
		.fail(function(e){
			callback(e);
		});
	},
	updateCompanySlug: function(slug, callback) {
		var url = "company/slug";
		var data = this.server.getData(url, {slug: slug}, true, "PUT");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			callback(e);
		});
	},
	getCompanySlug: function(callback) {
		var url = "company/slug";
		var data = this.server.getData(url, null, true, "GET");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			callback(e);
		});
	},
	validateCompanySlug: function(slug, callback) {
		var url = "company/slug/" + slug;
		var data = this.server.getData(url, null, true, "GET");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			callback(false);
		});
	},
	deleteCompanyLogo: function(callback) {
		var url = "company/logo"
		var data = this.server.getData(url, null, true, "DELETE");
		data
		.done(function(response){
			callback();
		})
		.fail(function(e){
			callback(false);
		});
	},
	deleteProfilePic: function(callback) {
		var url = "user/profilepicture"
		var data = this.server.getData(url, null, true, "DELETE");
		data
		.done(function(response){
			callback();
		})
		.fail(function(e){
			callback(false);
		});
	},
	forgotPassword: function(email, callback) {
		var url = "user/forgot";
		var data = this.server.getData(url, {email: email}, true, "POST");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			callback(false);
		});
	},
	resendEmailActivation: function(callback) {
		var url = "user/resend/activation";
		var data = this.server.getData(url, null, false, "GET");
		data
		.done(function(response){
			if (callback) {
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
		});
	},
	setReload: function(reload) {
        this.reload = reload;
    },
    forceUpdate: function() {
        this.reload();
    }
});

export let user = new User();


// WEBPACK FOOTER //
// app/core/controllers/user.js